<template>
  <div class="create-edit-order-modal petit-nature-modal">
    <div class="header">
      <h1 class="subtitle is-4" v-if="isCreateOrder">Novo pedido</h1>
      <h1 class="subtitle is-4" v-else>Editar pedido</h1>
      <span class="close-button" @click="$emit('close')">
        <i class="mdi mdi-window-close"></i>
      </span>
    </div>
    <form
      action=""
      class="body"
      novalidate
      @submit.prevent="validateBeforeSubmit"
    >
      <div class="columns is-multiline is-variable">
        <div class="column is-12">
          <label class="label">Status</label>
          <div class="block">
            <b-radio v-model="order.status" native-value="WAITING_APPROVAL">
              Aguardando aprovação
            </b-radio>
            <b-radio v-model="order.status" native-value="APPROVED">
              Aprovado
            </b-radio>
            <b-radio v-model="order.status" native-value="IN_PRODUCTION">
              Em produção
            </b-radio>
            <b-radio v-model="order.status" native-value="DELIVERING">
              Saiu para entrega
            </b-radio>
            <b-radio v-model="order.status" native-value="DELIVERED">
              Entregue
            </b-radio>
          </div>
        </div>

        <div class="column is-6" v-if="order.status === 'DELIVERED'">
          <b-field label="Data de entrega">
            <b-datepicker v-model="order.deliveredDate" icon="calendar-today">
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-6" v-if="order.status === 'DELIVERING'">
          <b-field label="Saiu para entrega em">
            <b-datepicker v-model="order.delivering_date" icon="calendar-today">
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-6" v-if="order.status === 'APPROVED'">
          <b-field label="Data de aprovação">
            <b-datepicker v-model="order.approvedDate" icon="calendar-today">
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-6" v-if="order.status === 'IN_PRODUCTION'">
          <b-field label="Em produção desde">
            <b-datepicker v-model="order.inProductionDate" icon="calendar-today">
            </b-datepicker>
          </b-field>
        </div>

        <div class="column is-12">
          <b-field label="Cliente">
            <b-autocomplete
              expanded
              v-model="customerSearchText"
              :data="customersList"
              placeholder="Buscar cliente"
              field="name"
              :loading="isFetching"
              :keep-first="true"
              @keyup.native="getCustomerAsyncData"
              @select="option => (selectedCustomer = option)"
            >
              <template slot-scope="props">
                <span>{{ props.option.name }}</span>
              </template>
              <template slot="empty">
                Nenhum resultado encontrado
              </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div class="column is-12">
          <div class="columns is-variable is-multiline">
            <div class="column is-6">
              <h1 class="subtitle" v-if="order.orderReceipts.length">
                Produtos
              </h1>
            </div>

            <div class="column is-6 has-text-right">
              <a class="button is-primary" @click="addReceipt">
                Adicionar produto</a
              >
            </div>
          </div>
        </div>
        <div class="column is-12">
          <OrderReceiptComponent
            :item="order.orderReceipts"
          ></OrderReceiptComponent>
        </div>
        <div class="footer column is-12 has-text-right">
          <div class="buttons is-right">
            <a class="button" @click="$emit('close')">Cancelar</a>
            <button
              type="submit"
              class="button is-primary"
              :class="{ 'is-loading': isPendingAction }"
              :disabled="isPendingAction"
            >
              <span v-if="isCreateOrder">Adicionar</span>
              <span v-else>Salvar</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import NotificationsWrapper from "../../helpers/NotificationsWrapper";
import QueryBuilder from "../../helpers/QueryBuilder";
import CustomerService from "../../services/CustomerService";
import utils from "../../helpers/debounce";
import BField from "buefy/src/components/field/Field";
import OrderReceiptComponent from "./OrderReceiptComponent";

export default {
  name: "CreateEditOrderModal",
  components: { OrderReceiptComponent, BField },
  computed: {
    ...mapState({ packings: state => state.packing.packings })
  },
  data: () => ({
    isCreateOrder: true,
    isPendingAction: false,
    order: { orderReceipts: [] },
    customerSearchText: "",
    customersList: [],
    selectedCustomer: {},
    isFetching: false
  }),
  methods: {
    ...mapActions({
      createOrder: "order/createOrder",
      editOrder: "order/editOrder"
    }),
    addReceipt() {
      let orderPackings = [];

      this.packings.forEach(pack => {
        let p = {
          quantity: 0,
          packing: { id: pack.id, size: pack.size }
        };
        orderPackings.push(p);
      });
      this.order.orderReceipts.push({
        id: new Date().getTime(),
        receipt: {},
        orderPackings: orderPackings
      });
    },
    validateBeforeSubmit() {
      if (this.isCreateOrder) {
        this.order.orderReceipts.forEach(item => delete item.id);
        this.order.customer = Object.assign({}, this.selectedCustomer);
        this.isPendingAction = true;
        this.createOrder(this.order)
          .then(() => {
            NotificationsWrapper.success("Pedido cadastrado com sucesso!");
            this.$emit("close");
            this.isPendingAction = false;
          })
          .catch(error => {
            this.isPendingAction = false;
            let errorCode = { error }.error.response.status;

            switch (errorCode) {
              default:
                NotificationsWrapper.error(
                  "Não foi possível criar o pedido. Tente novamente."
                );
                break;
            }
          })
          .finally(() => (this.isPendingAction = false));
      } else {
        this.isPendingAction = true;
        this.editOrder(this.order)
          .then(() => {
            NotificationsWrapper.success("Pedido atualizado com sucesso!");
            this.$emit("close");
          })
          .catch(error => {
            let errorCode = { error }.error.response.status;

            switch (errorCode) {
              default:
                NotificationsWrapper.error(
                  "Não foi possível atualizar o pedido. Tente novamente."
                );
                break;
            }
          })
          .finally(() => (this.isPendingAction = false));
      }
    },
    getCustomerAsyncData: utils.debounce(function() {
      this.customersList = [];
      let query = {
        isActiveFilter: 'TRUE',
        name: this.customerSearchText,
        size: 5
      };
      query = QueryBuilder.getQueryString(query);
      this.isFetching = true;
      CustomerService.getCustomers(query)
        .then(({ data }) => {
          this.customersList = data.content;
        })
        .finally(() => (this.isFetching = false));
    }, 300)
  },
  props: {
    orderParam: {}
  },
  created() {
    if (!this.orderParam.id) {
      this.isCreateOrder = true;
      this.order = { orderReceipts: [], status: "WAITING_APPROVAL" };
    } else {
      this.order = this.orderParam;

      // sort orderPackings by packings
      this.order.orderReceipts.forEach(or => {
        let auxPackings = [];
        this.packings.forEach(pack => {
          or.orderPackings.forEach(p => {
            if (pack.id === p.packing.id) {
              auxPackings.push(p);
            }
          });
        });
        or.orderPackings = auxPackings;
      });

      this.order.deliveredDate = this.order.deliveredDate ? new Date(this.order.deliveredDate) : null;
      this.order.approvedDate = this.order.approvedDate ? new Date(this.order.approvedDate) : null;
      this.order.inProductionDate = this.order.inProductionDate ? new Date(this.order.inProductionDate): null;
      this.order.delivering_date = this.order.delivering_date ? new Date(this.order.delivering_date) : null;
      this.selectedCustomer = this.order.customer;
      this.customerSearchText = this.order.customer.name;
      this.isCreateOrder = false;
    }
  }
};
</script>

<style scoped></style>
